import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import IconArrowRightLight from '~/assets/images/arrow-right-light.svg'
import { numberEnMap, numberCnMap } from '~/constants/numbers'
import { LOCALES } from '~/locales'

const ClosedLPCard = ({ lp, length, index, finalLP }) => {
  const { i18n, t } = useTranslation()
  const isZh = i18n.resolvedLanguage === LOCALES.ZH
  const phase = length - index
  const numericalOrder = isZh ? numberCnMap[phase] : numberEnMap[phase]
  let round: string | number = length - index
  if (round === 4) round = '4-7'

  return (
    <div className="closed-lp-container">
      <span className="phase-round">
        {t('round_no_1')}
        {round}
        {t('round_no_2')}
      </span>
      {lp.map((item) => (
        <Link
          key={item.id}
          href={`/lon/mining/lp/${item.id}?phase=${phase}`}
          prefetch
        >
          <div className="closed-item-container">
            <div className="logo-container">
              <img src={item.icon} className="logo" />
              <span className="token-pair">{item.title}</span>
            </div>
            <img src={IconArrowRightLight} />
          </div>
        </Link>
      ))}
      <div className="closed-note" style={{ marginTop: 18 }}>
        <p>
          {finalLP
            ? t('final_lp_note')
            : `${t('closed_note_period_1')}${numericalOrder}${t(
                'closed_note_period_2',
              )}`}
        </p>
      </div>
    </div>
  )
}

export default ClosedLPCard
